<template>
  <v-container fluid fill-height>
    <v-slide-y-transition mode="out-in">
              <v-layout row wrap>
                 <v-flex d-flex xs12 style="margin-top: 20px">
                  <v-layout column>
                    <v-flex d-flex>
                      <v-card style="">
                        <v-card-text>
                          <h3 style="text-align: left;margin-bottom: 10px">Accounted Customers Report</h3>
                          <v-btn flat class="primary" style="margin-left:900px;margin-bottom: 10px;margin-top:-40px" v-on:click="back()">Back</v-btn>
                          <v-divider divider: true></v-divider>
                          <v-layout row wrap>
                            <v-flex xs3 child-flex>
                              <v-layout row wrap>
                                <label style="margin-top:20px;margin-right: 10px">Show</label>
                                <v-overflow-btn
                                  :items="dropdown_list"
                                  label=""
                                  target="#dropdown-example"
                                ></v-overflow-btn>
                                <label style="margin-top:20px;margin-left: 10px">Entries</label>
                              </v-layout>
                            </v-flex>
                            <v-flex xs3 child-flex></v-flex>
                            <v-flex xs6 child-flex>
                              <v-layout row wrap>
                                <v-text-field
                                  label="Search"
                                ></v-text-field>
                                <v-btn class="primary" flat style="margin-top:10px;"><v-icon dark>search</v-icon></v-btn>
                                <v-btn class="primary" flat style="margin-top:10px;"><v-icon dark>list</v-icon></v-btn>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                          <v-data-table
                            :headers="headers"
                            :items="desserts"
                            class="elevation-1"
                            style="width:1200px"
                          >
                            <template slot="items" slot-scope="props">
                              <td>{{ props.item.no}}</td>
                              <td class="text-xs-left">{{ props.item.companyname }}</td>
                              <td class="text-xs-left">{{ props.item.address }}</td>
                              <td class="text-xs-left">{{ props.item.email }}</td>
                              <td class="text-xs-left">{{ props.item.selectregion }}</td>
                              <td class="text-xs-left">{{ props.item.selectcity }}</td>
                            </template>
                          </v-data-table>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      headers: [
        {
          text: '#',
          align: 'left',
          value: 'no'
        },
        { text: 'Company Name', value: 'companyname' },
        { text: 'Address', value: 'address' },
        { text: 'Email', value: 'email' },
        { text: 'Select Region', value: 'selectregion' },
        { text: 'Select City', value: 'selectcity' }
      ],
      desserts: [
        {
          no: '1',
          companyname: 'Jigyasa IMC',
          address: 'Fatima Nagar',
          email: 'rohitsupe03@gmail.com',
          selectregion: 'West',
          selectcity: 'Pune'
        },
        {
          no: '2',
          companyname: 'Wynum',
          address: 'Subhash Nagar',
          email: 'sales@wynum.com',
          selectregion: 'West',
          selectcity: 'Pune'
        }
      ]
    }
  },
  methods: {
    back () {
      this.$router.push('/Truckingaccountedcustomers')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Truckingaccountedcustomerreport.vue